import styled from 'styled-components';
import { TypographyProps } from '../types';
import { ReactNode } from 'react';

const StyledEyebrow = styled.div``;

const Eyebrow = ({
  as,
  children,
  desktopFont,
  tabletFont,
  mobileFont,
}: TypographyProps): ReactNode => {
  return <StyledEyebrow>{children}</StyledEyebrow>;
};

export default Eyebrow;
